import React, { useImperativeHandle, forwardRef, useContext, useRef } from "react";
import { Text } from "@fluentui/react";
import { SubledgerContext } from "../../contexts/SubledgerContext";
import MultiAutocomplete, { MultiAutocompleteRef } from "../../baseComponents/MultiAutocomplete";

interface ISLSearchDocumentTypeAutocompleteProps {
  loading: boolean;
}

export interface ISLSearchDocumentTypeAutocompleteRef {
  getDocumentTypes: () => string[];
  setInitialDocumentTypes: (initialDocumentTypes: string[]) => void;
  reset: () => void;
}

const SLSearchDocumentTypeAutocomplete = forwardRef((props: ISLSearchDocumentTypeAutocompleteProps, ref) => {
  const { documentTypes } = useContext(SubledgerContext);
  const autocompleteRef = useRef<MultiAutocompleteRef>(null);

  useImperativeHandle(ref, () => ({
    getDocumentTypes() {
      if (autocompleteRef.current) {
        return autocompleteRef.current.getSelectedItems();
      }
      return [];
    },
    setInitialDocumentTypes(initialDocumentTypes: string[]) {
      if (autocompleteRef.current) {
        autocompleteRef.current.setInitialSelectedItems(initialDocumentTypes);
      }
    },
    reset() {
      if (autocompleteRef.current) {
        autocompleteRef.current.reset();
      }
    }
  }));

  return (
    <React.Fragment>
      <MultiAutocomplete
        label="Document Types"
        required={false}
        items={documentTypes.value}
        ref={autocompleteRef}
        disabled={props.loading}
      />
      <Text
        nowrap
        variant="xSmall"
        block
        style={{
          marginTop: "4px",
          color: "var(--accent-font-color, #727272)"
        }}
      >
        Multiple document types enabled. Separate by semicolons.
      </Text>
    </React.Fragment>
  );
});

SLSearchDocumentTypeAutocomplete.displayName = "SLSearchDocumentTypeAutocomplete";

export default SLSearchDocumentTypeAutocomplete;
